<!-- Begin Top Bar -->
<div class="contain-to-grid" style=" display: flex; min-height: 50px; align-items: center; ">
  <nav class="header-bar" style="display: flex; padding: 0px; width: 96%; margin: 0 auto; max-width: 1920px;">
    <!-- Title Area -->
    <div style="display: flex; width: 100%; align-items: center; flex-wrap: wrap;" *ngIf="(isPortalNavVisibled | async)">
      <a href="javascript:void(0);" class="name me-1" *ngIf="(portalLogo | async) != ''" style="cursor:default;">
        <img [src]="portalLogo | async" alt="logo" class="img-fluid" style="display: block; max-width: 225px; max-height: 35px; width: auto; height: auto;"/>
      </a>
      <div>
        <h2 class="m-0 mx-2" [innerHTML]="portalDisplayName | async"></h2>
      </div>
    </div>
    <div style="display: flex; align-items: center; width: 100%; padding: 7px 0;" *ngIf="!(isPortalNavVisibled | async)">
      <a [routerLink]="['/Dashboard']" class="name" style="width: 100%;" [style.cursor]="(IsDashbord) ? 'default' : 'pointer'">
        <img [src]="HeaderBrandingIconPath" alt="logo" style="max-width: 150px;" />
      </a>
    </div>
    <div class="header-bar-section" *ngIf="!IsMobileMode">
      <!-- Right Nav Section -->
      <ul id="desktopsearchwrap">
        <!--Search-->
        <li id="topmenu-search" class="topmenu-search top-menu-icon" *ngIf="(isPortalSearchVisibled | async)">
          <a href="javascript:void(0)" >
            <img src="{{cdnEndPoint}}/triport/icons/community/search.svg" alt="Search" (click)="onPortalSearch($event)" />
          </a>
          <div class="dropdown-menu finduser-wrap" [formGroup]="myGroup">
            <div class="form-control-wrap" >
              <input type="text" id="searchByTxt" name="search" placeholder="Search" autocomplete="off" (keydown.enter)="onPortalSearch($event)" formControlName="searchText">
              <div class="finduser-clear">
                <img alt="Search" src="{{cdnEndPoint}}/triport/icons/community/search-white.svg" style="height: 75%; width: 75%; display: flex;" (click)="onPortalSearch($event)">
              </div>
            </div>
            <div class="search-backdrop" style="display: block; position: fixed; height: 100%; width: 100%; background: #fff; background: rgba(255,255,255,.5); top: 0; left: 0; z-index: 1;"></div>
          </div>
        </li>

        <!--Admin tools-->
        <li *ngIf="isPortalToolVisibled | async" id="topmenu-admin" class="topmenu-admin top-menu-icon" ngbDropdown #toolDrop="ngbDropdown" (mouseover)='over(toolDrop)' (mouseout)='out(toolDrop)' display="dynamic" placement="bottom-end">
          <a href="javascript:void(0)" ngbDropdownAnchor id="drpMenuTool"></a>
          <div id="menu-container-topmenu-admin" class="menu-control-container topmenu-admin-cls rounded-0" (click)="toolDrop.toggle()" ngbDropdownMenu aria-labelledby="drpMenuTool">
            <div *ngFor="let item of toolsMenu | async">
              <div class="groupheader li-menu-items" onclick="return false;" *ngIf="item.ShowGroupHeader">{{item.DisplayName}}</div>
              <div id="menu-analytics" style="display:flex;" class="li-menu-items" *ngFor="let subitem of item.AdminToolSubMenu | orderBy : 'Ordinal'" routerLinkActive="dropdown-active">

                <a [href]="((subitem.SubMenuDisplayName.toLowerCase() === 'portal admin') ? AppUrl : AdminAppUrl) + subitem.SubMenuUrl"  *ngIf="subitem.IsExternalLink">  <span class="menu-{{subitem.SubMenuName}} top-menu-icon"></span>  {{subitem.SubMenuDisplayName}}</a>   
                <a routerLink="{{subitem.SubMenuUrl}}" *ngIf="!subitem.IsExternalLink"><span class="menu-{{subitem.SubMenuName}} top-menu-icon" medpt-log-action="View" [attr.medpt-log-message]="'Navigate to ' + subitem.SubMenuName + ' page'"></span> {{subitem.SubMenuDisplayName}}</a>
              </div>
            </div>
          </div>
        </li>
        <!--Notification-->
        <medpt-user-notification></medpt-user-notification>
        <!--Help-->
        <li id="topmenu-help" class="topmenu-help top-menu-icon" ngbDropdown #helpDrop="ngbDropdown" (mouseover)='over(helpDrop)' (mouseout)='out(helpDrop)' display="dynamic" placement="bottom-end">
          <a href="javascript:void(0)" ngbDropdownAnchor id="drpMenuHelp"></a>
          <div id="menu-container-topmenu-help" class="menu-control-container topmenu-help-cls rounded-0" (click)="helpDrop.toggle()" ngbDropdownMenu aria-labelledby="drpMenuHelp">
            <div id="menu-help" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active" [routerLinkActiveOptions]="{exact: true}">
              <a href="javascript:void(0);" [routerLink]="['./Help']"><span class="menu-help top-menu-icon"></span> Help</a>
            </div>
            <div id="menu-contact" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active" [routerLinkActiveOptions]="{exact: true}">
              <a href="javascript:void(0);" [routerLink]="['./Contact']"><span class="menu-contact top-menu-icon"></span> Contact</a>
            </div>
          </div>
        </li>
        <!--User-->
        <li id="topmenu-user" class="topmenu-useraccount top-menu-icon" ngbDropdown #userDrop="ngbDropdown" (mouseover)='over(userDrop)' (mouseout)='out(userDrop)' display="dynamic" placement="bottom-end">
          <a href="javascript:void(0)" ngbDropdownAnchor id="drpMenuUser"></a>
          <div id="menu-container-topmenu-user" class="menu-control-container topmenu-user-cls rounded-0" (click)="userDrop.toggle()" ngbDropdownMenu aria-labelledby="drpMenuUser">
            <div id="menu-changepassword" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a href="{{myAppUrl}}/Account/Manage/ChangePassword"><span class="menu-changepassword top-menu-icon"></span> Change password</a>
            </div>
            <div id="menu-myaccount" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a routerLink="/Account/MyAccount" medpt-log-action="View" [attr.medpt-log-message]="'Navigate to My account page'"><span class="menu-myaccount top-menu-icon"></span> My account</a>
            </div>
            <div id="menu-manage-passkey" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a href="{{secureAppUrl}}/Account/Manage/Passkeys"><span class="menu-manage-passkey top-menu-icon"></span> Manage Passkeys</a>
            </div>
            <div id="menu-logout" style="display:flex;" class="li-menu-items" routerLinkActive="dropdown-active">
              <a href="javascript:void(0);" (click)="logout()"><span class="menu-logout top-menu-icon"></span> Logout</a>
            </div>
          </div>
        </li>
        <!--My apps and other medpt apps-->
        <li class="separator"></li>
        <li id="app-menu" class="appmenu-header" medpt-apps-menu></li>
        <li class="separator"></li>
      </ul>
    </div>

    <!--Mobile nav-->
    <div class="mobile-nav" *ngIf="IsMobileMode">
      <ul class="d-flex m-0 p-0 justify-content-center align-items-center">
        <!--Search-->
        <li *ngIf="(isPortalSearchVisibled | async)" class="pe-2">
          <a href="javascript:void(0)" class="searchico"  (click)="openSearchWindow(mobilesearchcontent)">
            <img src="{{cdnEndPoint}}/triport/icons/community/search.svg" alt="Search" />
          </a>
        </li>
        <!--Notification-->
        <medpt-user-notification></medpt-user-notification>
        <!--Navigation menus-->
        <li class="mt-2" ngbDropdown #mobNavDrop="ngbDropdown" display="dynamic" placement="bottom-end" (openChange)="resetMobileMenu($event, mobNavDrop)">
          <a href="javascript:void(0)" class="menuico" ngbDropdownToggle><span class="icon-menu"></span></a>

          <section class="rounded-0" style="min-width: 185px; align-items: center;z-index:1500;" (click)="mobNavDrop.toggle()" ngbDropdownMenu>
            <ul class="d-flex m-0 p-0 flex-column overflow-hidden" (click)="$event.stopPropagation()">
              <li class="my-1 me-1 has-dropdown dropdown" *ngIf="portalList.length > 1">
                <a class="d-block ps-2 pe-3" routerLinkActive="dropdown-active" href="javascript:void(0);" (click)="portallistopened=!portallistopened">Studies</a>
                <ul class="flex-column dropdown-menu rounded-0 d-block position-relative border-0 py-1" *ngIf="portallistopened">
                  <li>
                    <div class="col-12 p-3">
                      <div class="input-group">
                        <input ngbAutofocus (keyup)="applyFilter($event);" [(ngModel)]="searchText" type="text" id="txtSearch" class="m-0" placeholder="Search for Studies.." aria-label="Search" aria-describedby="Search-addon" autocomplete="off" />
                        <span id="Search-addon" style="position: absolute; right: 2px; top: 0px; text-align: center; width: 30px; z-index: 3; cursor: pointer; height: 100%; display: flex; justify-content: center; align-items: center; ">
                          <img src="{{cdnEndPoint}}/triport/icons/community/search.svg" alt="Search" style="height: 75%;" />
                        </span>
                      </div>
                    </div>
                  </li>
                  <li *ngFor="let studyPortal of filteredPortalList" class="px-2">
                    <a class="p-1 d-block" (click)="mobNavDrop.toggle();searchText='';applyFilter(null);" routerLinkActive="dropdown-active" href="/Go/{{studyPortal.SponsorName}}/{{studyPortal.PortalName}}" *ngIf="(!isStudyStat && !isRaspberryAI)">{{studyPortal.DisplayName}}</a>
                    <a class="p-1 d-block" (click)="mobNavDrop.toggle();searchText='';applyFilter(null);" routerLinkActive="dropdown-active" routerLink="/Go/{{studyPortal.SponsorName}}/{{studyPortal.PortalName}}/StudyStat/StudyResources" *ngIf="isStudyStat">{{studyPortal.DisplayName}}</a>
                    <a class="p-1 d-block" (click)="mobNavDrop.toggle();searchText='';applyFilter(null);" routerLinkActive="dropdown-active"routerLink="/Go/{{studyPortal.SponsorName}}/{{studyPortal.PortalName}}/RASPberryAI" *ngIf="isRaspberryAI">{{studyPortal.DisplayName}}</a>
                  </li>
                </ul>
              </li>

              <li class="my-1 me-1 " [ngClass]="{'has-dropdown dropdown' : nav.ChildFeatures.length > 0}" *ngFor="let nav of mobileNavigationMenu | async as nm;">

<a class="d-block ps-2 pe-3"
   routerLinkActive="dropdown-active"
   href="javascript:void(0);"
   (click)="mobNavDrop.close()"
   routerLink="/Go/{{sponsorName}}/{{portalName}}/{{
      nav.FeatureName == 'SafetyReports' ? 'SafetyReports' :
      nav.FeatureName == 'CloudPortDocuments' ? 'Documents' :
      nav.FeatureName == 'StudyResources' ? 'StudyStat' :
      nav.FeatureName == 'StudyMetrics' ? 'StudyStat' :
      nav.FeatureName == 'RASPberryAI' ? 'AI' :
      nav.FeatureName == 'RAIMetrics' ? 'AI' :
      'Documents'
   }}/{{ 
      nav.FeatureName == 'SafetyReports' ? 'SafetyReports' :
      nav.FeatureName == 'CloudPortDocuments' ? 'CloudPortDocuments' :
      nav.FeatureName == 'StudyResources' ? 'StudyResources' :
      nav.FeatureName == 'StudyMetrics' ? 'StudyMetrics' :
      nav.FeatureName == 'RASPberryAI' ? 'RASPberryAI' :
      nav.FeatureName == 'RAIMetrics' ? 'RAIMetrics' :
      'CloudPortDocuments'
   }}"
   id="drpMenu{{nav.FeatureName}}"
   *ngIf="nav.ChildFeatures.length == 0 
          || nav.FeatureName == 'SafetyReports' 
          || nav.FeatureName == 'CloudPortDocuments'
          || nav.FeatureName == 'StudyResources'
          || nav.FeatureName == 'StudyMetrics'
          || nav.FeatureName == 'RASPberryAI' 
          || nav.FeatureName == 'RAIMetrics'"
   medpt-log-action="View"
   [attr.medpt-log-message]="'Navigate to ' + nav.FeatureName + ' page'">
   {{nav.DisplayName}}
</a>

                <a class="d-block ps-2 pe-3" routerLinkActive="dropdown-active" href="javascript:void(0);" (click)="nav.opened=!nav.opened" id="drpMenu{{nav.FeatureName}}" *ngIf="nav.ChildFeatures.length > 0">{{nav.DisplayName}}</a>
                <ul class="flex-column dropdown-menu rounded-0 d-block position-relative border-0 py-1" *ngIf="nav.opened">
                  <li class="px-2" *ngFor="let childnav of nav.ChildFeatures">
                    <a class="p-1 d-block" href="javascript:void(0);" (click)="mobNavDrop.close()" routerLinkActive="dropdown-active" routerLink="/Go/{{sponsorName}}/{{portalName}}/{{nav.FeatureName}}/{{childnav.FeatureName}}" id="drpMenu{{nav.FeatureName}}" medpt-log-action="View" [attr.medpt-log-message]="'Navigate to ' + nav.FeatureName + ' page'">{{childnav.DisplayName}}</a>
                  </li>
                </ul>
              </li>

              <li class="my-1 me-1 has-dropdown dropdown" *ngFor="let item of toolsMenu | async">
                <a *ngIf="isPortalToolVisibled | async" class="d-block ps-2 pe-3" href="javascript:void(0);" (click)="item.opened=!item.opened" id="drpMobileToolMenu{{item.MenuGroupName}}">{{item.MenuGroupName=='AdminTools' ? 'Admin' : 'MedPoint'}}</a>
                <ul *ngIf="(isPortalToolVisibled | async) && item.opened" class="flex-column dropdown-menu rounded-0 d-block position-relative border-0 py-1">
                  <li class="px-2" *ngFor="let subitem of item.AdminToolSubMenu | orderBy : 'Ordinal'">
                    <a class="p-1 d-block" (click)="mobNavDrop.close()" routerLinkActive="dropdown-active" href="{{AdminAppUrl}}{{subitem.SubMenuUrl}}" *ngIf="subitem.IsExternalLink" id="drpMobileToolSubMenu{{subitem.SubMenuName}}">{{subitem.SubMenuDisplayName}}</a>
                    <a class="p-1 d-block" (click)="mobNavDrop.close()" routerLinkActive="dropdown-active" routerLink="{{subitem.SubMenuUrl}}" *ngIf="!subitem.IsExternalLink" id="drpMobileToolSubMenu{{subitem.SubMenuName}}" medpt-log-action="View" [attr.medpt-log-message]="'Navigate to ' + subitem.SubMenuName + ' page'">{{subitem.SubMenuDisplayName}}</a>
                  </li>
                </ul>
              </li>

              <li class="my-1">
                <a class="p-1 ps-2 d-block" routerLinkActive="dropdown-active" href="javascript:void(0);" [routerLink]="['./Help']" (click)="mobNavDrop.close()">Help</a>
              </li>
              <li class="my-1">
                <a class="p-1 ps-2 d-block" routerLinkActive="dropdown-active" href="javascript:void(0);" [routerLink]="['./Contact']" (click)="mobNavDrop.close()">Contact</a>
              </li>
              <li class="my-1">
                <a class="p-1 ps-2 d-block" routerLinkActive="dropdown-active" href="{{myAppUrl}}/Account/Manage/ChangePassword" (click)="mobNavDrop.close()">Change password</a>
              </li>
              <li class="my-1">
                <a class="p-1 ps-2 d-block" routerLinkActive="dropdown-active" href="javascript:void(0);" routerLink="/Account/MyAccount" (click)="mobNavDrop.close()"  medpt-log-action="View" [attr.medpt-log-message]="'Navigate to My account page'">My account</a>
              </li>
              <li class="my-1">
                <a class="p-1 ps-2 d-block" routerLinkActive="dropdown-active" href="{{secureAppUrl}}/Account/Manage/Passkeys" (click)="mobNavDrop.close()">Manage Passkeys</a>
              </li>
              <li class="my-1">
                <a class="p-1 ps-2 d-block" routerLinkActive="dropdown-active" href="javascript:void(0);" (click)="logout();mobNavDrop.close()"  medpt-log-action="View" [attr.medpt-log-message]="'Navigate to secure app logout page'">Logout</a>
              </li>
            </ul>
          </section>

        </li>
        <!--My apps and other medpt apps-->
        <li class="separator"></li>
        <li id="app-menu" class="appmenu-header" medpt-apps-menu></li>
        <li class="separator"></li>
      </ul>
    </div>
  </nav>
</div>
<!-- End Top Bar -->
<!-- Navigation Bar -->
<div class="nav-container" style="display: flex; padding: 0px; min-height: 50px; align-items: center;" *ngIf="(isPortalNavVisibled | async)">
  <nav class="top-bar" style="display: flex; padding: 5px 0px; width: 96%; margin: 0 auto; max-width: 1920px;">
    <medpt-navigation-menu [navigationMenu]="navigationMenu | async" [Sponsor]="sponsorName" [Portal]="portalName" style="width: inherit;"></medpt-navigation-menu>
    <div style="flex: 1 1; align-items: center; width: 100%; justify-content: end;">
      <a href="javascript:void(0);" style="cursor:default;">
        <img [src]="HeaderBrandingIconPath" alt="logo" style="max-width: 150px;min-width: 85px;" />
      </a>
    </div>
  </nav>
</div>

<medpt-raspberry-ai *ngIf="isAIEnabled"></medpt-raspberry-ai>
<ng-template #mobilesearchcontent let-offcanvas>
  <div class="offcanvas-body">
    <div class="row">
      <div class="col-12 my-3">
        <div class="input-group" [formGroup]="myGroup">
          <input formControlName="searchText" style="border: 1px solid #00A0F6; width: 100%;border-radius:0px;" type="text" id="txtSearch" class="m-0 form-control" placeholder="Search" aria-label="Search" aria-describedby="Search-addon" autocomplete="off" (keydown.enter)="onPortalSearch($event);" />
          <span id="Search-addon" style="position: absolute; right: 2px; top: 0px; text-align: center; width: 30px; z-index: 3; cursor: pointer; height: 100%; display: flex; justify-content: center; align-items: center; "
                (click)="onPortalSearch($event);">
            <img src="{{cdnEndPoint}}/triport/icons/community/search.svg" alt="Search" style="height: 75%;" />
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
